import React from 'react';
import ENDPOINTS from '../../../../constants/endpoints';
import useDefaultRequest from '../../../../hooks/useDefaultRequest';
import ReportChartCard from '../../../../components/admin/reports/ReportChartCard';
import HorizontalBarChart from '../../../../components/admin/reports/charts/HorizontalBarChart';

export default function OilTypesChart({dateFrom, dateTo}) {
    const {data, isLoading} = useDefaultRequest({
        url: ENDPOINTS.REPORTS_PATIENTS_OIL_TYPES,
        params: {date_from: dateFrom, date_to: dateTo},
        dataDefault: {},
    });
    const distribution = data?.distribution || [];

    return (
        <ReportChartCard title="Tipos de Óleo por Paciente" loading={isLoading} isEmpty={!distribution.length}>
            <HorizontalBarChart
                data={distribution}
                dataKey="patients"
                nameKey="oil_type"
                tooltipFields={[
                    {key: 'patients', label: 'Pacientes'},
                    {key: 'items', label: 'Itens'},
                    {key: 'qty', label: 'Quantidade'},
                ]}
            />
        </ReportChartCard>
    );
}
